"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetPositionType = exports.IconStyle = exports.IconShape = exports.EmbedWidgetStatus = exports.EmbedWidgetMode = exports.EmbedCampaignAudience = exports.EmbedSignedIdentityRequiredStatus = exports.EmbedTeamUserStatus = void 0;
var EmbedTeamUserStatus;

(function (EmbedTeamUserStatus) {
  EmbedTeamUserStatus["UNKNOWN"] = "UNKNOWN";
  EmbedTeamUserStatus["ENABLED"] = "ENABLED";
})(EmbedTeamUserStatus = exports.EmbedTeamUserStatus || (exports.EmbedTeamUserStatus = {}));

var EmbedSignedIdentityRequiredStatus;

(function (EmbedSignedIdentityRequiredStatus) {
  EmbedSignedIdentityRequiredStatus["ENABLED"] = "ENABLED";
  EmbedSignedIdentityRequiredStatus["DISABLED"] = "DISABLED";
  EmbedSignedIdentityRequiredStatus["REQUIRED"] = "REQUIRED";
})(EmbedSignedIdentityRequiredStatus = exports.EmbedSignedIdentityRequiredStatus || (exports.EmbedSignedIdentityRequiredStatus = {}));

var EmbedCampaignAudience;

(function (EmbedCampaignAudience) {
  EmbedCampaignAudience["EVERYONE"] = "EVERYONE";
  EmbedCampaignAudience["VISITORS"] = "VISITORS";
  EmbedCampaignAudience["USERS"] = "USERS";
  EmbedCampaignAudience["SEGMENT"] = "SEGMENT";
  EmbedCampaignAudience["NONE"] = "NONE";
  EmbedCampaignAudience["PREVIOUS"] = "PREVIOUS";
})(EmbedCampaignAudience = exports.EmbedCampaignAudience || (exports.EmbedCampaignAudience = {}));

var EmbedWidgetMode;

(function (EmbedWidgetMode) {
  EmbedWidgetMode["AUTO"] = "AUTO";
  EmbedWidgetMode["MANUAL"] = "MANUAL";
})(EmbedWidgetMode = exports.EmbedWidgetMode || (exports.EmbedWidgetMode = {}));

var EmbedWidgetStatus;

(function (EmbedWidgetStatus) {
  EmbedWidgetStatus["ON"] = "ON";
  EmbedWidgetStatus["OFF"] = "OFF";
  EmbedWidgetStatus["AWAY"] = "AWAY";
})(EmbedWidgetStatus = exports.EmbedWidgetStatus || (exports.EmbedWidgetStatus = {}));

var IconShape;

(function (IconShape) {
  IconShape["CIRCLE"] = "circle";
  IconShape["SQUARE"] = "square";
})(IconShape = exports.IconShape || (exports.IconShape = {}));

var IconStyle;

(function (IconStyle) {
  IconStyle["SOLID1"] = "SOLID1";
  IconStyle["SOLID2"] = "SOLID2";
  IconStyle["OUTLINE1"] = "OUTLINE2";
  IconStyle["BOLT"] = "BOLT";
})(IconStyle = exports.IconStyle || (exports.IconStyle = {}));

var WidgetPositionType;

(function (WidgetPositionType) {
  WidgetPositionType["CUSTOM"] = "CUSTOM";
  WidgetPositionType["DEFAULT"] = "DEFAULT";
})(WidgetPositionType = exports.WidgetPositionType || (exports.WidgetPositionType = {}));